import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import gif1 from '../../../../../globals/images/eco-gif.gif';
import gif2 from '../../../../../globals/images/b2b-gif.gif';
import graph from '../../../../../globals/images/company-graph.png';
import styles from './company.module.scss';
import analytics from './../../../../../utils/segmentUtils'

class Company extends Component {
    componentDidMount() {
        analytics.page('Company')
    }

    render() {
        let { introductionData } = this.props;
        let leftTopImage = introductionData.step1.leftTopGif ? introductionData.step1.leftTopGif : gif1;
        let leftBottomImage = introductionData.step1.leftBottomGif ? introductionData.step1.leftBottomGif : gif2;
        let rightImage = introductionData.step1.rightImage ? introductionData.step1.rightImage : graph;

        return (
            <div className={styles['company-info-container']}>
                <div className={styles['info-left']}>
                    <div className={styles['info-left-top']}>
                        <div className={styles['info-text-left']} dangerouslySetInnerHTML={{ __html: introductionData.step1.leftTopText }} />
                        <div className={styles['info-left-image']} >
                            <img src={leftTopImage} className={styles['info-left-image']} />
                        </div>
                    </div>
                    <div className={styles['info-left-bottom']}>
                        <div className={styles['info-text-left']} dangerouslySetInnerHTML={{ __html: introductionData.step1.leftBottomText }} />
                        <div className={styles['info-left-image']} >
                            <img src={leftBottomImage} className={styles['info-left-image']} />
                        </div>
                    </div>
                </div>

                <div className={styles['info-right']}>
                    <div className={styles['graph-container']}>
                        <img src={rightImage} className={styles['graph']} />
                    </div>
                    <div className={styles['info-text-right']} dangerouslySetInnerHTML={{ __html: introductionData.step1.rightText }} />
                </div>
            </div >
        )
    }
}

export default Company;


// WEBPACK FOOTER //
// /src/components/intro/pages/about/company/Company.js